module.exports = __webpack_public_path__ + "img/in-feed-sample.f309bb94.png";